/* eslint-disable bsky-internal/avoid-unwrapped-text */
import {Defs, G, Mask, Path, Rect, Svg, Text as SvgText} from 'react-native-svg'

import widentityPhone from '../../../assets/images/onboarding/illus_widentity_phone_v2.png'

export const ILLUS_BG = '#2b2932'
export const ILLUS_TEAL = '#11E8B2'

function WavePaths({transform}: {transform: string}) {
  const d: string[] = [
    'M0.0782216 62.7267C32.7743 82.709 107.136 68.5311 136.649 24.8224C172.667 -28.519 250.073 16.8172 289.424 46.8126',
    'M66.0782 158.768C98.7743 178.75 173.136 164.572 202.649 120.863C238.667 67.522 316.073 112.858 355.424 142.854',
    'M58.5235 147.1C91.2196 167.082 165.581 152.904 195.095 109.196C231.112 55.8542 308.518 101.19 347.869 131.186',
    'M124.524 243.141C157.22 263.123 231.581 248.945 261.095 205.236C297.112 151.895 374.518 197.231 413.869 227.226',
    'M30.172 104.971C62.868 124.953 137.23 110.775 166.743 67.0665C202.761 13.7252 280.166 59.0613 319.517 89.0568',
    'M96.172 201.012C128.868 220.994 203.23 206.816 232.743 163.107C268.761 109.766 346.166 155.102 385.517 185.098',
    'M15.1212 84.1388C47.8172 104.121 122.179 89.9432 151.692 46.2345C187.71 -7.10688 265.116 38.2293 304.467 68.2248',
    'M81.1212 180.18C113.817 200.162 188.179 185.984 217.692 142.276C253.71 88.9341 331.116 134.27 370.467 164.266',
    'M45.211 126.383C77.9071 146.365 152.269 132.187 181.782 88.4784C217.8 35.137 295.206 80.4732 334.557 110.469',
    'M111.211 222.424C143.907 242.406 218.269 228.228 247.782 184.52C283.8 131.178 361.206 176.514 400.557 206.51',
    'M2.97275 66.7775C35.6688 86.7598 110.031 72.5819 139.544 28.8732C175.561 -24.4682 252.967 20.868 292.318 50.8635',
    'M68.9728 162.818C101.669 182.801 176.031 168.623 205.544 124.914C241.561 71.5728 318.967 116.909 358.318 146.904',
    'M61.422 151.151C94.118 171.133 168.48 156.955 197.993 113.246C234.011 59.905 311.416 105.241 350.767 135.237',
    'M127.422 247.191C160.118 267.174 234.48 252.996 263.993 209.287C300.011 155.946 377.416 201.282 416.767 231.277',
    'M33.0587 109.022C65.7547 129.004 140.117 114.826 169.63 71.1173C205.647 17.7759 283.053 63.1121 322.404 93.1076',
    'M99.0587 205.063C131.755 225.045 206.117 210.867 235.63 167.158C271.647 113.817 349.053 159.153 388.404 189.149',
    'M18.0196 88.1895C50.7157 108.172 125.077 93.9939 154.591 50.2853C190.608 -3.0561 268.014 42.2801 307.365 72.2755',
    'M84.0196 184.231C116.716 204.213 191.077 190.035 220.591 146.326C256.608 92.9849 334.014 138.321 373.365 168.317',
    'M48.1095 130.433C80.8055 150.416 155.167 136.238 184.681 92.5292C220.698 39.1879 298.104 84.524 337.455 114.519',
    'M114.109 226.475C146.806 246.457 221.167 232.279 250.681 188.57C286.698 135.229 364.104 180.565 403.455 210.561',
    'M5.28525 70.8283C37.9813 90.8107 112.343 76.6327 141.856 32.9241C177.874 -20.4173 255.28 24.9188 294.631 54.9143',
    'M71.2853 166.869C103.981 186.851 178.343 172.673 207.856 128.965C243.874 75.6234 321.28 120.96 360.631 150.955',
    'M56.5001 152.519C94.115 176.824 170.792 161.006 200.305 117.297C236.322 63.9556 313.728 109.292 353.079 139.287',
    'M122.5 248.56C160.115 272.865 236.792 257.047 266.305 213.338C302.322 159.997 379.728 205.333 419.079 235.328',
    'M35.3829 113.072C68.079 133.055 142.441 118.877 171.954 75.1681C207.972 21.8267 285.377 67.1629 324.728 97.1584',
    'M101.383 209.113C134.079 229.096 208.441 214.918 237.954 171.209C273.972 117.868 351.377 163.204 390.728 193.199',
    'M20.336 92.2403C53.0321 112.223 127.394 98.0447 156.907 54.3361C192.925 0.994685 270.331 46.3308 309.682 76.3263',
    'M86.336 188.281C119.032 208.264 193.394 194.086 222.907 150.377C258.925 97.0357 336.331 142.372 375.682 172.367',
    'M50.422 134.484C83.118 154.467 157.48 140.289 186.993 96.5801C223.011 43.2387 300.416 88.5748 339.767 118.57',
    'M116.422 230.525C149.118 250.508 223.48 236.33 252.993 192.621C289.011 139.28 366.416 184.616 405.767 214.611',
    'M8.76182 75.4571C41.4579 95.4395 115.82 81.2615 145.333 37.5529C181.35 -15.7885 258.756 29.5476 298.107 59.5431',
    'M74.7618 171.498C107.458 191.48 181.82 177.303 211.333 133.594C247.35 80.2525 324.756 125.589 364.107 155.584',
    'M38.8517 117.703C71.5477 137.686 145.909 123.508 175.423 79.799C211.44 26.4576 288.846 71.7937 328.197 101.789',
    'M104.852 213.742C137.548 233.725 211.909 219.547 241.423 175.838C277.44 122.497 354.846 167.833 394.197 197.828',
    'M23.8048 96.8694C56.5008 116.852 130.863 102.674 160.376 58.9652C196.393 5.6238 273.799 50.9599 313.15 80.9554',
    'M89.8048 192.91C122.501 212.892 196.863 198.714 226.376 155.006C262.393 101.664 339.799 147.001 379.15 176.996',
    'M53.8985 139.113C86.5946 159.096 160.956 144.918 190.47 101.209C226.487 47.8677 303.893 93.2039 343.244 123.199',
    'M119.899 235.155C152.595 255.137 226.956 240.959 256.47 197.25C292.487 143.909 369.893 189.245 409.244 219.241',
    'M11.6563 79.5079C44.3524 99.4903 118.714 85.3123 148.227 41.6037C184.245 -11.7377 261.651 33.5984 301.002 63.5939',
    'M77.6563 175.549C110.352 195.531 184.714 181.353 214.227 137.645C250.245 84.3033 327.651 129.639 367.002 159.635',
    'M41.7423 121.754C74.4383 141.736 148.8 127.558 178.313 83.8497C214.331 30.5084 291.737 75.8445 331.088 105.84',
    'M107.742 217.793C140.438 237.775 214.8 223.597 244.313 179.889C280.331 126.547 357.737 171.884 397.088 201.879',
    'M26.6993 100.92C59.3954 120.902 133.757 106.724 163.27 63.0158C199.288 9.67437 276.694 55.0105 316.045 85.006',
    'M92.6993 196.961C125.395 216.943 199.757 202.765 229.27 159.057C265.288 105.715 342.694 151.051 382.045 181.047',
    'M56.7892 143.164C89.4852 163.147 163.847 148.969 193.36 105.26C229.378 51.9185 306.784 97.2547 346.135 127.25',
    'M122.789 239.205C155.485 259.188 229.847 245.01 259.36 201.301C295.378 147.96 372.784 193.296 412.135 223.291',
  ]
  return (
    <G transform={transform}>
      {d.map((path, i) => (
        <Path key={i} d={path} stroke="white" strokeWidth="0.8" fill="none" />
      ))}
    </G>
  )
}

export function IllustrationEurope() {
  return (
    <Svg width="308" height="352" viewBox="0 0 308 352" fill="none">
      <Rect width="308" height="352" rx="20" fill={ILLUS_BG} />
      <Defs>
        <Mask
          id="mask-europe"
          x="0"
          y="0"
          width="308"
          height="352"
          maskUnits="userSpaceOnUse">
          <WavePaths transform="translate(-45.077, 52.313)" />
        </Mask>
      </Defs>
      <G mask="url(#mask-europe)">
        <Path
          transform="translate(28.85, 102.02)"
          d="M213.861 162.67L214.311 162.819V162.969H214.835L215.283 162.595H215.583L215.808 162.521H216.032C216.033 162.595 216.331 162.745 216.331 162.745L216.48 162.521H216.705L216.93 162.819V163.269L217.154 163.119L217.379 163.269H217.453C217.453 163.194 217.978 163.344 217.978 163.344V163.418L217.828 163.643V164.092C217.753 164.092 217.678 164.241 217.678 164.241H217.453L217.304 164.391L216.93 164.54H216.78L216.331 164.84H216.032C216.032 164.765 215.657 164.84 215.657 164.84L215.434 165.139L215.283 164.915H214.909L214.685 164.69L214.386 164.915H214.012L213.637 164.765H213.263C213.262 164.69 212.97 164.471 212.964 164.466L212.739 164.017L212.515 163.792L212.365 163.269L212.216 163.044V162.819L212.664 163.044H212.964L213.113 162.745V162.521L213.413 162.445H213.562C213.562 162.52 213.712 162.37 213.712 162.37H213.861V162.67ZM180.039 161.622L183.107 161.323L186.101 161.622V162.521L188.195 161.922L187.821 163.344L182.134 163.718V162.969L177.121 161.996L177.719 159.977L180.039 161.622ZM141.053 158.929L141.203 159.078V159.303L141.053 159.527L140.679 159.378L140.305 159.153V158.779C140.305 158.704 140.754 158.704 140.754 158.704L141.053 158.929ZM226.508 133.039L232.419 134.91L236.76 134.161L240.201 134.61L244.317 132.066L248.433 131.842L252.623 134.236L253.596 135.883V138.202L256.813 139.399L258.609 140.746L256.14 142.168L258.311 147.63L257.786 149.127L260.63 152.942L258.834 153.766L257.263 152.568L252.548 151.895L250.977 152.644L246.562 153.392H244.392L240.127 155.112H236.834L234.589 154.215L230.398 155.562L228.978 154.663L229.127 157.282L228.229 158.33L227.256 159.378L225.535 157.208L226.807 155.412L224.412 155.86L220.971 154.738L218.576 157.507L212.59 158.03L209.072 155.486L204.808 155.337L204.059 157.282L201.365 157.881L197.324 155.337H192.984C192.984 155.412 190.141 150.623 190.141 150.623L186.998 148.004L188.494 144.263L185.801 141.943L189.617 137.379L195.604 137.229L196.801 133.562L204.283 134.236L208.474 131.168L212.814 129.821L219.175 129.672L226.508 133.039ZM174.95 49.3096H178.468V49.2354L179.141 49.9834L177.195 52.5273L178.991 56.7178L177.794 58.1387L179.665 59.1113L180.413 61.2812L181.984 63.9756L185.95 65.0977L186.624 66.2197L188.42 65.6963L192.012 66.7441L192.835 68.9141L192.311 70.1113L195.154 73.1045L196.726 73.9268V74.75L199.27 75.5732L200.542 76.7705L199.345 77.7432L196.427 77.5938L195.828 78.043L196.95 79.5391L198.447 82.5322L199.794 82.6816L200.542 81.6338L201.664 81.8584L205.331 81.4102L208.175 84.0283L207.501 85.001L208.1 86.4229L211.019 86.6475L212.739 88.668V89.5654L217.827 91.2119L220.521 90.4639L223.215 92.6338H225.386C225.386 92.559 231.147 94.0547 231.147 94.0547L231.446 95.4766L230.474 97.8711L231.82 100.49L231.596 102.062L228.004 102.36L226.358 103.708L226.657 105.728L223.739 106.102L221.494 107.673L218.052 107.897L215.059 109.693L215.808 112.611L217.902 113.734L221.719 113.435L221.27 115.156L217.229 115.979L212.515 118.673L210.195 117.7L210.719 115.53L206.304 114.108L206.828 113.21L210.27 111.639L208.998 110.592L202.937 109.395L202.338 107.599L198.971 108.197L197.998 110.816L195.528 114.258L195.828 115.53L194.106 116.503L192.909 116.054L192.61 121.815L190.291 121.292L187.298 119.57H187.297L190.29 121.292L192.61 121.815L190.89 123.761L189.916 127.128L191.487 129.821L192.161 131.692L195.753 133.188L195.229 134.386L190.59 134.61L189.093 136.106L186.175 138.651L184.679 136.481V135.508H184.604L182.209 135.358L180.188 134.91L175.549 136.106L178.542 138.801L176.672 139.624H174.502L172.182 137.154L171.509 138.202L172.706 141.045L174.876 143.29L173.454 144.338L175.849 146.508L177.943 147.93L178.243 150.623L174.502 149.351L175.849 151.82L173.379 152.27L175.25 156.534H172.631C172.631 156.609 169.188 154.514 169.188 154.514L167.393 150.698L166.42 147.48L164.699 145.311L162.454 142.542L162.08 141.195L161.406 140.896L161.257 139.849L158.938 138.202L158.413 135.957V132.665L158.862 131.243L158.188 130.495L157.366 130.121L156.094 128.55L154.373 127.577H154.372L150.631 125.855L148.236 124.135L144.645 122.713L141.128 119.271L141.876 118.897L140.006 116.877L139.781 115.306L137.312 114.558L136.264 116.577L135.066 115.006V113.36C135.066 113.332 135.463 113.327 135.951 113.33L135.142 113.285L135.965 112.911L132.896 112.163L129.979 113.884L130.277 116.203L129.903 117.55L131.325 119.944L135.066 122.339L137.236 126.305L141.801 130.121H144.794L145.842 131.094L144.794 132.066L148.386 133.787L151.379 135.209L154.896 137.753L155.346 138.576L154.747 140.297L152.427 138.053L148.985 137.304L147.563 140.372L150.481 142.168L150.182 144.637L148.61 144.937L146.74 149.052L145.094 149.426V147.93L145.692 145.385L146.516 144.338L144.794 141.569L143.447 139.175L141.801 138.576L140.454 136.556L137.91 135.658L136.114 133.713L133.271 133.413L130.053 131.318L126.387 128.176L123.618 125.481L122.196 120.768L120.25 120.244L117.107 118.673L115.387 119.271L113.217 121.516L111.646 121.815L108.278 124.509L100.646 123.237L95.1084 124.809L94.6592 127.651L94.958 130.42L91.292 133.562L86.3525 134.61L85.9785 136.182L83.584 138.801L82.0879 142.691L83.584 145.46L81.3389 147.555L80.4414 150.698L77.4482 151.671L74.6797 155.337H69.5908C69.5908 155.412 65.8496 155.337 65.8496 155.337L63.3057 156.983L61.7344 158.779L59.7881 158.405L58.3672 156.759L57.3193 154.065L53.6523 153.316L52.0068 154.514L49.9111 153.841L47.8906 154.364L48.5645 150.623L48.3398 147.705L46.5439 147.256L45.7207 145.46L46.0947 142.317L47.7412 140.597L48.1152 138.651L49.0137 135.808V133.787L48.3398 132.066L48.1904 130.42L49.6123 129.223H49.6113L48.1904 130.42L48.5645 127.053L47.0674 125.033L52.6045 121.591L57.2441 122.414H62.4072L66.4482 123.237L69.666 122.938L75.877 123.162L77.8975 120.318L78.6455 110.891L74.8291 105.952L72.0605 103.558L66.374 101.762L66.0742 98.3203L70.9385 97.3477L77.1494 98.5449L76.0264 93.2324L79.5439 95.252L88.0742 91.6611L89.1963 87.8447L92.3389 86.8721L95.2578 85.9736L97.1279 84.7021L100.121 77.9678L104.985 76.0225L107.979 76.1719L108.577 75.1992L111.57 74.9746L112.318 75.9473L114.639 73.7031L113.666 71.9814L113.366 69.4375L111.795 66.8936L111.495 62.3291L111.944 61.0576L112.917 59.71L115.91 59.4863L117.107 58.2139L119.802 56.9414V59.2617L118.903 60.7578L119.428 61.9551L121.373 62.6289L120.625 64.3496L119.577 63.9004L117.258 67.1182L118.305 69.3633L118.529 71.084L122.196 72.1318V73.7773L125.788 72.8799L127.733 71.6826L131.924 73.4785L133.72 74.9004L136.039 73.5527L141.353 71.458L145.692 69.9619L149.284 70.71L149.733 71.832H153.175L157.59 72.3555H164.175C164.181 72.2829 166.046 72.8047 166.046 72.8047L164.175 72.2812H157.59C157.578 72.354 153.225 71.8378 153.176 71.832L153.699 69.8867L158.413 68.3896L157.142 64.5742L156.767 61.207L158.039 58.3633L161.107 56.8672L164.399 60.2344L167.168 60.085V56.6426L167.243 56.623V54.0234L166.046 54.6221L163.576 53.0508L162.828 50.5068L166.944 49.2354L171.135 48.6367L174.95 49.3096ZM140.229 158.404H140.005V158.479H139.631V158.255H139.931L140.229 158.404ZM143.148 151.671L143.821 153.092L143.148 155.562L140.006 153.766L137.985 153.242L132.373 150.848L132.747 148.378L137.387 148.827L141.427 148.304L144.42 147.854L143.148 151.671ZM121.448 137.005L121.148 143.365L119.353 143.065L117.781 144.637L116.284 143.365L115.91 137.604L114.938 134.91L117.107 135.134L118.979 133.638L121.448 137.005ZM167.542 134.984L164.998 135.358V136.631L164.395 136.969L165.073 136.631V135.358C164.998 135.358 167.543 134.984 167.543 134.984H167.542ZM169.569 128.33L171.658 129.896L172.257 133.039H172.331L171.732 129.896L169.638 128.325L169.569 128.33ZM120.101 129.148L118.979 132.814L117.183 131.842L116.21 128.699L116.883 126.903L119.277 125.107L120.101 129.148ZM166.569 126.679H167.075L167.094 126.604H166.569C166.566 126.675 165.746 125.781 165.746 125.781L166.569 126.679ZM145.992 114.558C145.99 114.635 145.243 115.68 145.243 115.68L145.992 114.632H147.713C147.721 114.559 151.06 115.375 151.08 115.38H153.699C153.703 115.345 154.15 115.587 154.597 115.839L155.495 116.354L153.699 115.306H151.08C151.076 115.379 147.745 114.565 147.713 114.558H145.992ZM155.495 116.354H156.888L156.917 116.278H155.549L155.495 116.354ZM154.372 111.34L155.271 112.836L154.373 111.34H154.372ZM109.026 111.001C109.361 111.181 110.659 112.005 110.672 112.014V112.013L109.026 110.966V111.001ZM135.216 108.571H135.217H135.216ZM144.121 106.925L143.447 107.748H140.155C140.155 107.822 138.38 108.933 138.359 108.945L140.155 107.823H143.447C143.447 107.748 144.121 106.925 144.121 106.925H144.144C144.206 106.708 144.405 106.069 144.607 105.438L145.094 103.932L144.121 106.925ZM153.25 101.163V101.164V101.163ZM104.985 94.8037H106.053C106.248 94.8723 107.829 95.9258 107.829 95.9258L106.033 94.7285H104.985C104.985 94.8033 104.162 94.4297 104.162 94.4297L104.985 94.8037ZM69.0674 57.7646L72.584 57.166H76.4004L75.4277 60.833L72.21 64.873L75.877 65.0977L76.1016 65.6221L79.2441 70.9346L81.6387 71.6826L83.8086 76.9199L84.8564 78.7158L89.2715 79.5391L88.8223 82.5322L87.0264 83.8789L88.4482 86.2734L85.1553 88.668H80.292C80.292 88.5931 74.0059 89.9395 74.0059 89.9395L72.3604 88.9668L69.8906 91.1367L66.5234 90.6133L63.8291 92.4092L61.959 91.5107L67.4209 86.6475L70.7139 85.5996L65.0264 84.8516L64.0537 82.9814L67.8701 81.5596L65.999 79.0898L66.748 76.0967L72.0605 76.5459L72.6592 73.8525L70.3398 71.084H70.2646C70.2646 71.0092 65.999 70.1855 65.999 70.1855L65.1758 68.9883L66.5234 66.9688L65.4004 65.6963L63.4551 67.8662V63.4521L61.7344 61.207L63.1562 56.5674L65.999 52.9766L68.6934 53.2754L72.8838 52.9014L69.0674 57.7646ZM63.0059 71.3086L60.9863 74.376L58.3672 73.4785H56.1494L56.1221 73.5527H58.3672C58.3759 73.4813 60.9863 74.376 60.9863 74.376L61.5098 77.668L58.5918 81.7842L52.0068 84.4775L46.918 83.8037L50.1357 79.0156L48.5645 74.376L53.5781 70.7842L56.3467 68.6895L59.3398 68.4648L63.0059 71.3086ZM127.883 66.5195L126.087 70.1855L122.196 67.5674L121.522 65.6963L126.611 64.2002L127.883 66.5195ZM178.094 2.91797L174.427 3.96582L178.468 6.50977L173.679 8.08105L171.284 8.45508L171.583 11.2988L177.046 14.0674L174.876 17.21L179.739 21.9238L178.468 25.5156L182.134 28.6582L181.461 31.501L186.998 34.4199L186.324 36.5898L183.78 39.1338L177.794 44.6709L171.808 45.0449L166.121 46.6162L160.808 47.5889L158.413 45.1943L154.896 43.7725V39.4326L152.727 35.542L153.924 32.998L156.393 30.3789L162.978 25.7402L164.924 24.8418L164.25 23.0459L159.386 21.1006L154.148 22.2979L151.529 25.2158L152.502 27.835L147.862 31.2021L142.025 34.9434L140.454 41.0039L143.223 44.0723L146.814 46.541L144.346 51.4795L140.903 52.5273L140.454 60.0098L138.883 64.2744L134.618 63.8262L132.972 67.417L128.855 67.6416L127.435 63.377L124.066 58.2139L120.924 51.9287L118.454 49.2354L112.02 54.3232L107.455 55.3701L102.591 53.126L101.244 48.4121L99.7471 38.3105L102.74 35.542L111.196 31.875L117.257 27.4609L122.645 21.624L129.305 13.6182L134.094 10.5498L141.801 5.46191L148.162 3.66602L153.175 3.89062L157.066 0.598633L162.604 0.748047L167.842 0L178.094 2.91797Z"
          fill={ILLUS_TEAL}
        />
      </G>
    </Svg>
  )
}

export function IllustrationPrivacy() {
  return (
    <Svg width="308" height="352" viewBox="0 0 308 352" fill="none">
      <Rect width="308" height="352" rx="20" fill={ILLUS_BG} />
      <Defs>
        <Mask
          id="mask-privacy"
          x="0"
          y="0"
          width="308"
          height="352"
          maskUnits="userSpaceOnUse">
          <WavePaths transform="translate(-59.078, 52.307)" />
        </Mask>
      </Defs>
      <G mask="url(#mask-privacy)">
        <Path
          transform="translate(75, 75.56)"
          d="M156 109.643C156 159.479 121.875 184.397 81.315 198.849C79.1911 199.585 76.884 199.55 74.7825 198.75C34.125 184.397 0 159.479 0 109.643V39.8731C0 37.2297 1.02723 34.6945 2.85571 32.8253C4.68419 30.9561 7.16414 29.906 9.75 29.906C29.25 29.906 53.625 17.9454 70.59 2.79528C72.6556 0.991217 75.2832 0 78 0C80.7168 0 83.3444 0.991217 85.41 2.79528C102.473 18.045 126.75 29.906 146.25 29.906C148.836 29.906 151.316 30.9561 153.144 32.8253C154.973 34.6945 156 37.2297 156 39.8731V109.643Z"
          fill={ILLUS_TEAL}
        />
      </G>
    </Svg>
  )
}

export function IllustrationScanSuccessful() {
  return (
    <Svg width="308" height="352" viewBox="0 0 308 352" fill="none">
      <Rect width="308" height="352" rx="20" fill={ILLUS_BG} />
      <Defs>
        <Mask
          id="mask-scan"
          x="0"
          y="0"
          width="308"
          height="352"
          maskUnits="userSpaceOnUse">
          <WavePaths transform="translate(-50, 52)" />
        </Mask>
      </Defs>
      <G mask="url(#mask-scan)">
        <Path
          transform="translate(63, 85)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M72.6494 7.89549C74.2685 5.46614 76.4625 3.4743 79.0366 2.09691C81.6107 0.719517 84.4851 -0.000782164 87.4046 6.37363e-07H94.3097C100.243 6.37363e-07 105.776 2.96194 109.065 7.89549L119.432 23.4502L135.323 19.7796C138.254 19.103 141.308 19.1833 144.2 20.013C147.091 20.8427 149.723 22.3945 151.85 24.5223L157.192 29.8738C161.517 34.1895 163.307 40.4314 161.935 46.3917L158.264 62.2826L173.819 72.6494C178.752 75.9384 181.714 81.4716 181.714 87.4046V94.3097C181.714 100.243 178.752 105.776 173.819 109.065L158.264 119.432L161.935 135.323C162.611 138.253 162.531 141.308 161.701 144.2C160.872 147.091 159.32 149.723 157.192 151.85L151.85 157.192C149.723 159.32 147.091 160.872 144.2 161.701C141.308 162.531 138.254 162.611 135.323 161.935L119.432 158.264L109.065 173.819C107.446 176.248 105.252 178.24 102.678 179.617C100.104 180.995 97.2292 181.715 94.3097 181.714H87.4046C84.4851 181.715 81.6107 180.995 79.0366 179.617C76.4625 178.24 74.2685 176.248 72.6494 173.819L62.2826 158.273L46.3917 161.944C43.4621 162.619 40.4091 162.538 37.5196 161.708C34.63 160.878 31.999 159.327 29.8738 157.201L24.5133 151.859C22.3886 149.731 20.8402 147.097 20.0137 144.206C19.1872 141.315 19.1098 138.261 19.7887 135.332L23.4502 119.441L7.89549 109.074C5.46487 107.454 3.47223 105.259 2.09477 102.683C0.717311 100.107 -0.00227446 97.2307 5.40061e-06 94.3097V87.4046C5.40061e-06 81.4716 2.96195 75.9384 7.89549 72.6494L23.4411 62.2826L19.7705 46.3917C19.0978 43.4606 19.1818 40.4066 20.0147 37.517C20.8476 34.6274 22.4019 31.9972 24.5314 29.8738L29.8829 24.5133C32.0099 22.3901 34.6418 20.8426 37.5312 20.0161C40.4206 19.1897 43.4728 19.1114 46.4007 19.7887L62.2917 23.4502L72.6494 7.89549ZM59.0571 90.8571C59.0571 86.6811 59.8797 82.546 61.4778 78.6878C63.0759 74.8297 65.4183 71.3241 68.3712 68.3711C71.3241 65.4182 74.8297 63.0759 78.6878 61.4778C82.546 59.8797 86.6811 59.0571 90.8572 59.0571C95.0332 59.0571 99.1683 59.8797 103.026 61.4778C106.885 63.0759 110.39 65.4182 113.343 68.3711C116.296 71.3241 118.638 74.8297 120.237 78.6878C121.835 82.546 122.657 86.6811 122.657 90.8571C122.657 99.291 119.307 107.379 113.343 113.343C107.379 119.307 99.291 122.657 90.8572 122.657C82.4233 122.657 74.3348 119.307 68.3712 113.343C62.4075 107.379 59.0571 99.291 59.0571 90.8571Z"
          fill={ILLUS_TEAL}
        />
      </G>
    </Svg>
  )
}

export function IllustrationWIdentity() {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        maxWidth: 308,
        borderRadius: 20,
        backgroundColor: ILLUS_BG,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        paddingTop: 30,
        paddingBottom: 30,
      }}>
      <img
        src={widentityPhone}
        alt=""
        style={{
          height: '100%',
          width: 'auto',
          objectFit: 'contain',
        }}
      />
    </div>
  )
}

export function IllustrationAge18() {
  return (
    <Svg width="260" height="212" viewBox="0 0 260 212" fill="none">
      <Rect width="260" height="212" rx="20" fill={ILLUS_BG} />
      <Defs>
        <Mask
          id="mask-age18"
          x="0"
          y="0"
          width="260"
          height="212"
          maskUnits="userSpaceOnUse">
          <WavePaths transform="translate(-45, -20)" />
        </Mask>
      </Defs>
      <G mask="url(#mask-age18)">
        <SvgText
          x="130"
          y="155"
          textAnchor="middle"
          fontSize="140"
          fontWeight="700"
          fill={ILLUS_TEAL}
          letterSpacing="-6">
          18
        </SvgText>
      </G>
    </Svg>
  )
}

export function IllustrationCongrats() {
  return (
    <Svg width="308" height="352" viewBox="0 0 308 352" fill="none">
      <Rect width="308" height="352" rx="20" fill={ILLUS_BG} />
      <Defs>
        <Mask
          id="mask-congrats"
          x="0"
          y="0"
          width="308"
          height="352"
          maskUnits="userSpaceOnUse">
          <WavePaths transform="translate(-55, 50)" />
        </Mask>
      </Defs>
      <G mask="url(#mask-congrats)">
        <Path
          transform="translate(70, 100)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M159.501 3.84327C161.622 5.39093 163.417 7.34122 164.784 9.58273C166.15 11.8242 167.062 14.313 167.467 16.907C167.871 19.5009 167.761 22.1491 167.142 24.7004C166.523 27.2517 165.407 29.6559 163.858 31.7759L82.139 143.698C80.5747 145.842 78.5992 147.653 76.3276 149.025C74.056 150.397 71.5339 151.303 68.9084 151.69C66.2829 152.077 63.6066 151.937 61.0358 151.279C58.4649 150.621 56.0509 149.457 53.9346 147.855L7.73459 112.864C3.57893 109.639 0.861813 104.907 0.172465 99.6925C-0.516882 94.478 0.877114 89.202 4.05216 85.0086C7.2272 80.8152 11.9273 78.0424 17.1333 77.2916C22.3392 76.5408 27.6313 77.8725 31.8619 80.9978L61.8411 103.702L131.569 8.20025C134.694 3.91978 139.392 1.05608 144.629 0.239004C149.866 -0.578069 155.212 0.718405 159.493 3.84327H159.501Z"
          fill={ILLUS_TEAL}
        />
      </G>
    </Svg>
  )
}

export function IllustrationVerify() {
  return (
    <Svg width="308" height="352" viewBox="0 0 308 352" fill="none">
      <Rect width="308" height="352" rx="20" fill={ILLUS_BG} />
      <Defs>
        <Mask
          id="mask-verify"
          x="0"
          y="0"
          width="308"
          height="352"
          maskUnits="userSpaceOnUse">
          <WavePaths transform="translate(-56.078, 74.808)" />
        </Mask>
      </Defs>
      <G mask="url(#mask-verify)">
        <Path
          transform="translate(80, 83.8)"
          d="M40.2799 150.376C56.2461 152.7 47.9002 173.132 41.7314 183.058C66.1162 193.807 107.531 172.527 125.191 160.544C119.143 154.613 115.031 139.845 123.014 125.683C132.196 109.392 142.367 86.1002 144.06 74.8428C152.188 12.9638 105.596 -0.811277 81.2839 0.0360487C5.44444 4.03059 13.4277 54.507 13.4277 66.4906C13.4277 78.4742 -7.98184 102.804 3.26708 102.441C14.516 102.078 15.242 111.157 13.4277 129.677C11.6133 148.197 20.3222 147.471 40.2799 150.376Z"
          fill={ILLUS_TEAL}
        />
      </G>
    </Svg>
  )
}

export function QrCodeIllustration() {
  return (
    <Svg width="308" height="352" viewBox="0 0 308 352" fill="none">
      <Rect width="308" height="352" rx="20" fill={ILLUS_BG} />
      <Rect x="84" y="80" width="140" height="192" rx="12" fill="#1a1825" />
      <Rect x="100" y="96" width="40" height="40" rx="4" fill={ILLUS_TEAL} />
      <Rect x="106" y="102" width="28" height="28" rx="2" fill="#1a1825" />
      <Rect x="112" y="108" width="16" height="16" rx="1" fill={ILLUS_TEAL} />
      <Rect x="168" y="96" width="40" height="40" rx="4" fill={ILLUS_TEAL} />
      <Rect x="174" y="102" width="28" height="28" rx="2" fill="#1a1825" />
      <Rect x="180" y="108" width="16" height="16" rx="1" fill={ILLUS_TEAL} />
      <Rect x="100" y="192" width="40" height="40" rx="4" fill={ILLUS_TEAL} />
      <Rect x="106" y="198" width="28" height="28" rx="2" fill="#1a1825" />
      <Rect x="112" y="204" width="16" height="16" rx="1" fill={ILLUS_TEAL} />
      <Rect
        x="148"
        y="96"
        width="8"
        height="8"
        rx="1"
        fill={ILLUS_TEAL}
        opacity="0.8"
      />
      <Rect
        x="160"
        y="96"
        width="8"
        height="8"
        rx="1"
        fill={ILLUS_TEAL}
        opacity="0.8"
      />
      <Rect
        x="152"
        y="108"
        width="8"
        height="8"
        rx="1"
        fill={ILLUS_TEAL}
        opacity="0.6"
      />
      <Rect
        x="148"
        y="120"
        width="8"
        height="8"
        rx="1"
        fill={ILLUS_TEAL}
        opacity="0.8"
      />
      <Rect
        x="164"
        y="120"
        width="8"
        height="8"
        rx="1"
        fill={ILLUS_TEAL}
        opacity="0.8"
      />
      <Rect
        x="148"
        y="152"
        width="8"
        height="8"
        rx="1"
        fill={ILLUS_TEAL}
        opacity="0.8"
      />
      <Rect
        x="160"
        y="152"
        width="8"
        height="8"
        rx="1"
        fill={ILLUS_TEAL}
        opacity="0.6"
      />
      <Rect
        x="168"
        y="152"
        width="8"
        height="8"
        rx="1"
        fill={ILLUS_TEAL}
        opacity="0.8"
      />
      <Rect
        x="180"
        y="152"
        width="8"
        height="8"
        rx="1"
        fill={ILLUS_TEAL}
        opacity="0.8"
      />
      <Rect
        x="148"
        y="164"
        width="8"
        height="8"
        rx="1"
        fill={ILLUS_TEAL}
        opacity="0.8"
      />
      <Rect
        x="164"
        y="164"
        width="8"
        height="8"
        rx="1"
        fill={ILLUS_TEAL}
        opacity="0.8"
      />
      <Rect
        x="176"
        y="164"
        width="8"
        height="8"
        rx="1"
        fill={ILLUS_TEAL}
        opacity="0.6"
      />
      <Rect
        x="148"
        y="176"
        width="8"
        height="8"
        rx="1"
        fill={ILLUS_TEAL}
        opacity="0.6"
      />
      <Rect
        x="160"
        y="176"
        width="8"
        height="8"
        rx="1"
        fill={ILLUS_TEAL}
        opacity="0.8"
      />
      <Rect
        x="172"
        y="176"
        width="8"
        height="8"
        rx="1"
        fill={ILLUS_TEAL}
        opacity="0.8"
      />
      <Rect
        x="180"
        y="176"
        width="8"
        height="8"
        rx="1"
        fill={ILLUS_TEAL}
        opacity="0.6"
      />
      <Rect
        x="148"
        y="192"
        width="8"
        height="8"
        rx="1"
        fill={ILLUS_TEAL}
        opacity="0.8"
      />
      <Rect
        x="168"
        y="192"
        width="8"
        height="8"
        rx="1"
        fill={ILLUS_TEAL}
        opacity="0.8"
      />
      <Rect
        x="180"
        y="192"
        width="8"
        height="8"
        rx="1"
        fill={ILLUS_TEAL}
        opacity="0.6"
      />
      <Rect
        x="152"
        y="204"
        width="8"
        height="8"
        rx="1"
        fill={ILLUS_TEAL}
        opacity="0.8"
      />
      <Rect
        x="164"
        y="204"
        width="8"
        height="8"
        rx="1"
        fill={ILLUS_TEAL}
        opacity="0.6"
      />
      <Rect
        x="176"
        y="204"
        width="8"
        height="8"
        rx="1"
        fill={ILLUS_TEAL}
        opacity="0.8"
      />
      <Rect
        x="152"
        y="216"
        width="8"
        height="8"
        rx="1"
        fill={ILLUS_TEAL}
        opacity="0.6"
      />
      <Rect
        x="168"
        y="216"
        width="8"
        height="8"
        rx="1"
        fill={ILLUS_TEAL}
        opacity="0.8"
      />
      <Rect
        x="180"
        y="216"
        width="8"
        height="8"
        rx="1"
        fill={ILLUS_TEAL}
        opacity="0.8"
      />
      <Rect
        x="84"
        y="176"
        width="140"
        height="2"
        rx="1"
        fill={ILLUS_TEAL}
        opacity="0.3"
      />
    </Svg>
  )
}
